import { Autocomplete, Chip, TextField } from "@mui/material";
import React, { Dispatch, RefObject, useState } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { useWorkoutSettings } from "../../../providers/workout-settings";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  gear: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const GearInput = ({ handleErrorRefs, dispatch, loading, gear }: Props) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const { activeEquipment } = useWorkoutSettings();
  const options = Array.from(
    new Set([
      ...activeEquipment.map((equipment) => equipment.name),
      ...utrustning,
    ])
  );
  const handleError = () => {
    setError(gear.error);
    setMessage(gear.message);
  };
  handleErrorRefs.current?.push(handleError);

  return (
    <Autocomplete
      disabled={loading}
      multiple
      id="gear"
      options={options}
      freeSolo
      onChange={(e, v) => {
        dispatch({
          type: FormInputs.gear,
          payload: v,
        });
        setTimeout(handleError, 300);
      }}
      value={gear.input as string[]}
      renderTags={(values: readonly string[], getTagProps) => {
        return values.map((option: string, index: number) => {
          return (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          );
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          helperText={message}
          onBlur={handleError}
          variant="outlined"
          label="Utrustning"
          placeholder="Utrustning"
        />
      )}
    />
  );
};

export default GearInput;
const utrustning: string[] = ["skor", "skridskor", "vattenflaska"];
